/* eslint-disable global-require */
import React, { ErrorInfo, FC } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import Constants from 'app/shared/constants/constants';
import getBrandName from "app/shared/utils/BrandHelper";
import logging from "app/shared/utils/logging";
import RootFallBackComponent from "app/shared/components/RootFallBackComponent";
import App from './App';
import { store } from './app/store';
import './fonts/Zen_Kurenaido/ZenKurenaido-Regular.ttf';
import './fonts/Rancho/Rancho-Regular.ttf';
import './fonts/Lato/Lato-Regular.ttf';
import './fonts/Melvyn_Regular/Melvyn_Regular.otf';
import './fonts/Jost/Jost-Bold.ttf';
import './fonts/Jost/Jost-SemiBold.ttf';
import './fonts/Jost/Jost-Regular.ttf';
import './fonts/Besley/Besley-Bold.ttf';
import './fonts/Besley/Besley-BoldItalic.ttf';

const EbbTheme = React.lazy(() => import('./ebbTheme/EbbTheme'));
const BruTheme = React.lazy(() => import('./bruTheme/BruTheme'));
const NnybTheme = React.lazy(() => import('./nnybTheme/NnybTheme'));
const { brandName } = getBrandName();

type ThemeProps = {
    children: React.ReactNode;
};

const ThemeSelector: FC<ThemeProps> = ({ children }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Suspense fallback={<></>}>
        {(brandName === Constants.EINSTEIN_APP) && <EbbTheme />}
        {(brandName === Constants.BRUEGGERS_APP) && <BruTheme />}
        {(brandName === Constants.NOAH_APP) && <NnybTheme />}
        {children}
    </React.Suspense>
);

const handleError = (error: Error, info: ErrorInfo) => {
    logging.debug("_MAIN_COMP_ERR", `Issue getting value for ${info.componentStack || ""}`, error);// Ember Azure insights here
};

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = createRoot(rootElement);

    root.render(
        <Provider store={store}>
            <ThemeSelector>
                <ErrorBoundary
                    onError={handleError}
                    FallbackComponent={RootFallBackComponent}
                >
                    <App />
                </ErrorBoundary>
            </ThemeSelector>
        </Provider>,
    );
}
